import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { Panel } from './Panel';

const sample: Dictionary<{ title: string; body: string; current: string }> = {
  pl: {
    title: 'Portfele',
    body: 'Treść panelu: tabela, formularz albo kilka akapitów.',
    current: 'Edytowany cel',
  },
  en: {
    title: 'Wallets',
    body: 'Panel content: a table, a form or a few paragraphs.',
    current: 'Goal being edited',
  },
};

export default {
  kind: 'component',
  title: { pl: 'Panel', en: 'Panel' },
  description: {
    pl: 'Biała karta, na której stoi treść strony. `title` dodaje nagłówek sekcji; `tone="highlight"` wyróżnia panel, na którym strona właśnie działa.',
    en: 'The white card page content sits in. `title` adds the section heading; `tone="highlight"` marks the panel the page is currently acting on.',
  },
  variants: [
    {
      name: { pl: 'Z tytułem', en: 'With a title' },
      render: (locale) => (
        <Panel title={sample[locale].title}>
          <p>{sample[locale].body}</p>
        </Panel>
      ),
    },
    {
      name: { pl: 'Wyróżniony', en: 'Highlighted' },
      render: (locale) => (
        <Panel title={sample[locale].current} tone="highlight">
          <p>{sample[locale].body}</p>
        </Panel>
      ),
    },
    {
      name: { pl: 'Bez tytułu', en: 'Without a title' },
      render: (locale) => (
        <Panel>
          <p>{sample[locale].body}</p>
        </Panel>
      ),
    },
  ],
} satisfies Story;
